<template>
      <div class="form-checkout-container d-flex justify-content-center align-items-center flex-column padding-5">
        <!-- VeeValidate Form -->
         <div class="d-flex justify-content-center align-items-center flex-column">
           <p >  Thanks for starting the process of booking a health consultation. A
            member of the team will be in touch shortly.</p>
         </div>
        <router-link :to="{ name: 'dashboard' }" class="back-button">Back To Home</router-link>
      </div>
  </template>
  
  <script>
  import "../../../../styles/pages/BloodTestDetails.scss";
  
  export default {
    name: 'ConsultationModal',
 
    mounted() {
      console.log("Success")
    }
  };
  </script>
  